const IMAGES = {
  bictorBong: require("../images/bictor_bong.png"),
  general: require("../images/general.png"),
  jonie: require("../images/jonie.png"),
  oldHead: require("../images/old.png"),
  paddi: require("../images/paddi.png"),
  smarc: require("../images/smarc.png"),
  sparky: require("../images/sparky.png"),
  tibbie: require("../images/tibbie.png"),
  weslie: require("../images/weslie.png"),
  willie: require("../images/willie.png"),
  wolffy: require("../images/wolffy.png"),
  wolnie: require("../images/wolnie.png"),
  jay: require("../images/jay.png"),
};

export default IMAGES;
